import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_GROUPPERFORMANCE_REQUEST = 'FETCH_GROUPPERFORMANCE_REQUEST';
export const FETCH_GROUPPERFORMANCE_SUCCESS = 'FETCH_GROUPPERFORMANCE_SUCCESS';
export const FETCH_GROUPPERFORMANCE_FAILURE = 'FETCH_GROUPPERFORMANCE_FAILURE';

const buildPerformanceUrl = (groupId) => buildUrl(`/groups/${groupId}/students-performance`);
const method = 'GET';

export function getGroupPerformanceByGroupId(state, groupId) {
  return state.get('rootReducer').get('groupPerformance').get(groupId);
}

export function isLoadingGroupPerformance(state, groupId) {
  const callState = ApiCall.find(state, { method: 'GET', url: buildPerformanceUrl(groupId) });
  return ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState);
}

export function fetchGroupPerformanceIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method, url: buildPerformanceUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchGroupPerformance(groupId));
  };
}

export function fetchGroupPerformance(groupId) {
  return (dispatch) => {
    const url = buildPerformanceUrl(groupId);

    return dispatch(fetchGroupPerformanceRequest()).payload
      .then((response) => dispatch(fetchGroupPerformanceSuccess(response)))
      .catch((error) => dispatch(fetchGroupPerformanceFailure(error)));

    function fetchGroupPerformanceRequest() {
      return ApiCall.createAction({
        type: FETCH_GROUPPERFORMANCE_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchGroupPerformanceSuccess(groupPerformance) {
      return ApiCall.createAction({
        type: FETCH_GROUPPERFORMANCE_SUCCESS,
        payload: groupPerformance,
        url,
        method,
        groupId,
      });
    }

    function fetchGroupPerformanceFailure(error) {
      return ApiCall.createAction({
        type: FETCH_GROUPPERFORMANCE_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/GroupPerformance/actions.js